import { getProviderWithPrepayCards } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/prepay-cards';

export default async ({ $apolloQuery, route, store }) => {
  await $apolloQuery(getProviderWithPrepayCards, { slug: route.params.provider }).then(provider => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('provider.description', { provider: provider.name });
    const title = store.$i18n.t('provider.jumbotron.title', { provider: provider.name });
    store.commit('pageContent/setHead', { title, description });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/prepay-cards', '/compare-prepaid-credit-cards/'],
      ['i18n/providers', '/compare-prepaid-credit-cards/providers/'],
      provider.name
    ]);
    store.commit('blog/setList', provider.articles);
    store.commit('products/setList', provider.prepay_cards);
    delete provider.articles;
    delete provider.prepay_cards;
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('providers/set', provider);
  });
};
